import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import { List } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

class GeneralIndex extends Component {

  constructor(props) {
    super(props)

    this.state = {

    }
    this.contentUpdate = this.contentUpdate.bind(this)
  }


  updateHash(val) {
    window.location.hash = val
  }


  contentUpdate(data) {
    this.props.onContentChange(data)
  }

  render() {
   
    return (

      <Paper>
        <div style={{ width: '100%', padding: '15px' }}>
          <b>Table of Contents</b>
          <div>
            <List>


              <ListItem button onClick={() => { this.contentUpdate('q1'); this.updateHash('q1') }}>
                <ListItemText primary="1.How to log into Param Portal?" />
              </ListItem>
              <ListItem button onClick={() => { this.contentUpdate('q2'); this.updateHash('q2') }}>
                <ListItemText primary="2.What are the Default options available in Param?" />
              </ListItem>

            </List>
          </div>
        </div>
      </Paper>




    )
  }
}
export default GeneralIndex
